var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 my-5"},[_vm._v(" "+_vm._s(_vm.$t('Licenses'))+" ")]),_vm._l((_vm.ac.items),function(app){return _c('HdToggleField',{key:app.appId,attrs:{"model":app},on:{"valuechange":_vm.onValueChange}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }